import React from 'react';
import { FormattedMessage } from 'react-intl';
import Text from '../../../../../global/text/text';
import { DefaultClosePopoverButton } from '../../../../../global/common-popover/default-close-popover-button';
import { CloseIcon } from '../../../../../global/icons/icons';
import { LinksViewModel } from './links.viewmodel';
import { ILinkDTO } from '../../../../../../api/meetings.dao';
import { DELETE_TEXT } from '../../../../../../constants/common-labels.constants';

type Props = {
    onDelete: () => void;
    vm: LinksViewModel;
} & ILinkDTO;

export const LinkItemInfoPopover = (
    props: Props
): JSX.Element => {

    return (
        <>
            <div className='oe-popup-layout__header'>
                <DefaultClosePopoverButton
                    className='event-link__popover-close'
                    icon={CloseIcon}
                    modifier={['link']}
                    text=''
                />
            </div>
            <div className='event-item-link__popover-body'>
                <div className='event-item-link__info m-bottom-15px'>
                    <div className='event-item-link__info-title'>
                        <FormattedMessage id='oe.common.eventLinkLabel' defaultMessage='Label' />:
                    </div>
                    <div className='event-item-link__info-value'>
                        <Text tag='div' message={props.label} />
                    </div>
                </div>
                <div className='event-item-link__info'>
                    <div className='event-item-link__info-title'>
                        <FormattedMessage id='oe.common.eventLinkUrl' defaultMessage='URL' />:
                    </div>
                    <div className='event-item-link__info-value'>
                        <Text tag='div' message={props.url} />
                    </div>
                </div>

            </div>
            {props.onDelete && (
                <DefaultClosePopoverButton
                    text={<FormattedMessage {...DELETE_TEXT} />}
                    modifier='link-warn'
                    className='popup-footer-remove-button event-item-link__remove-button'
                    onClick={props.onDelete}
                />
            )}

        </>
    );
};
